import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors as bsColors } from '@resiliatech/birdsong'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      marginTop: '50px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    contentText: {
      fontWeight: 600,
      fontSize: '32px',
      lineHeight: '125%',

      marginBottom: '35px',
    },
    contentSvg: {
      width: '90%',
    },
    title: {
      '& h1': {
        color: bsColors.copy.headerDark,
      },
    },
  })
)

export default useStyles
